
import React from 'react';
import MainLayout from '@/components/Layout/MainLayout';
import ContactHero from '@/components/Contact/ContactHero';
import ContactForm from '@/components/Contact/ContactForm';
import ContactInfo from '@/components/Contact/ContactInfo';
import LocationMap from '@/components/Contact/LocationMap';
import ContactFAQ from '@/components/Contact/ContactFAQ';

const Contact = () => {
  return (
    <MainLayout>
      {/* Hero Section */}
      <ContactHero />

      {/* Contact Form and Details */}
      <section className="py-12 bg-white" aria-labelledby="contact-form">
        <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 px-4">
          <ContactForm />
          <ContactInfo />
        </div>
      </section>

      {/* Map Section */}
      <LocationMap />

      {/* FAQ Section */}
      <ContactFAQ />
    </MainLayout>
  );
};

export default Contact;
